<template>
  <div class="top-header">
    <div class="bg">
      <div class="right-bg"></div>
    </div>
    <el-header class="layout-header">
      <div class="layout-header-logo">
        <img class="layout-header-logo-img" src="~@/assets/image/logo-zgc.png" alt="" />
      </div>
      <div class="cur-system">
        <div
          style="display: flex; align-items: center; cursor: pointer"
          @click.stop="backHome"
        ></div>
        <div class="select-box" v-if="listNew.length">
          <div
            v-for="(item, index) in listNew"
            :key="index"
            :class="{ active: selectActive == item.id }"
            class="select-box-item"
            @click="menuListChnage(item)"
          >
            <img
              style="height: 32px; margin-right: 8px"
              :src="require(`@/assets/image/${item.data.menuCode}.png`)"
              alt=""
            />
            <span>{{ item.data.menuName }}</span>
          </div>
        </div>
      </div>
      <div class="layout-header-right">
        <el-dropdown>
          <div
            style="
              color: #fff;
              margin-left: 5px;
              margin-right: 10px;
              font-size: 16px;
              display: flex;
              align-items: center;
            "
          >
            <div class="tupian">
              <img style="height: 32px" src="~@/assets/image/touxiang.png" alt="" />
            </div>
            <div
              style="
                height: 40px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 150px;
                line-height: 40px;
              "
            >
              {{ userName }}
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <div @click="logout">
                <i class="iconfont1 icon-shut-down-line"></i> 退出登录
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String || Number,
      default: null,
    },
    list: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      userName: "请登录",
      name: "",
      selectActive: "",
      listNew: [],
      listDaping: [],
      dialogVisible: false,
    };
  },

  created() {
    // this.userName = JSON.parse(sessionStorage.getItem("userInfo")).userName;

    this.listNew = this.list.filter((item) => item.data.menuCode != "patrolScreen");
    this.listDaping = this.list.filter(
      (item) => item.data.menuCode == "patrolScreen" && !item.data.hidden
    );
  },
  methods: {
    menuListChnage(item) {
      if (!item || !item.children.length) return;
      this.selectActive = item.id;
      sessionStorage.setItem("curDefaultActive", "");
      this.$emit("initMenu", item.children);
    },
    logout() {
      sessionStorage.clear(); // 清除权限、用户信息
      localStorage.clear(); // 清除权限、用户信息
      this.$router.push({
        path: "/login",
      });
    },
    jump() {
      this.$router.push({
        path: "/patrolScreen",
      });
    },
    handleCommand(command) {
      command == "a"
        ? this.$router.push({
            path: "/patrolLargeScreen",
          })
        : this.$router.push({
            path: "/patrolScreen",
          });
    },
  },
  computed: {},
  watch: {
    id: {
      handler(val) {
        this.selectActive = this.id;
      },
      deep: true,
    },
    list: {
      handler(val) {
        this.listNew = val.filter((item) => item.data.menuCode != "patrolScreen");
        this.listDaping = val.filter(
          (item) => item.data.menuCode == "patrolScreen" && !item.data.hidden
        );
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="less">
.top-header {
  position: relative;
  height: 64px !important;
  width: 100%;

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("~@/assets/image/top-bg.png") no-repeat !important;
    background-size: 100% 100% !important;

    .right-bg {
      position: absolute;
      right: 0;
      top: 0;
      height: 64px;
      width: 1088px;
      background: url("~@/assets/image/top-right-bg.png") no-repeat !important;
      background-size: 100% 100% !important;
    }
  }
}

/deep/.el-dropdown-menu__item:hover {
  background-color: #ebecf0;
  color: #646466;
}

.header-right-i {
  display: inline-block;
  margin-left: 5px;
}

.layout-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  height: 64px !important;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
}

.layout-header-logo {
  width: 216px;
  height: 44px;
}

.cur-system {
  width: calc(100% - 440px);
  text-align: left;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.layout-header-logo-img {
  // width: 100%;
  height: 100%;
}

.layout-header-right {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -20px;
  .daping {
    cursor: pointer;
    height: 40px;
    width: 144px;
    background: url("~@/assets/image/daping_btn.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    margin-right: 20px;
  }
}

/deep/ .layout-header .el-input__inner {
  background: none;
  border: none;
  font-family: PingFangSC, PingFang SC;
  font-weight: 700;
  font-size: 18px;
  color: #ffffff;
}

/deep/ .layout-header .el-select .el-input .el-select__caret {
  color: #fff;
}

/deep/ .layout-header .el-button--mini {
  height: 28px;
  line-height: 1;
  border-radius: 4px;
  border: 1px solid #ffffff;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  background: none;
}

.select-box {
  display: flex;
  align-items: center;
  height: 64px;
  cursor: pointer;

  .select-box-item {
    width: 238px;
    height: 100%;

    font-family: PingFangSC, PingFang SC, bold;
    font-size: 20px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .select-box-item.active {
    background: linear-gradient(
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.15) 100%
    );
    position: relative;
  }

  .select-box-item.active::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: #ffffff;
  }
}

.tupian {
  display: flex;
  align-content: center;
  justify-content: center;
  margin-left: 5px;
  margin-right: 5px;
  height: 32px;
  margin-right: 4px;
}

.visualLargeScreen {
  margin-right: 10px;
  background: url("~@/assets/image/daping_btn.png") no-repeat;
  background-size: 100% 100%;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/forbidden/header.vue